'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fast';
var iconName = 'chevron-down';
var width = 512;
var height = 512;
var aliases = [];
var unicode = 'f078';
var svgPathData = 'M256 403.3l5.7-5.7 208-208 5.7-5.7L464 172.7l-5.7 5.7L256 380.7 53.7 178.3 48 172.7 36.7 184l5.7 5.7 208 208 5.7 5.7z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faChevronDown = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;